import React from 'react';
import { faCircle as faCircleLigth } from '@fortawesome/pro-light-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { CustomLabel6, CustomLabel8 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { useTheme } from 'styled-components';
import TableCaptionItem from '../../atoms/Table/CaptionItem';

function LegendaSituacaoColaborador() {
  const theme = useTheme();

  return (
    <>
      <CustomLabel8>Situação do colaborador:</CustomLabel8>
      <CustomLabel6>
        <TableCaptionItem
          labelText="Contratado"
          icon={faCircleLigth}
        />
        <TableCaptionItem
          labelText="Em Afastamento"
          icon={faCircle}
          color={theme.corColaboradorAfastado}
        />
        <TableCaptionItem
          labelText="Sem Contrato Assinado"
          icon={faCircle}
          color={theme.corColaboradorSemContrato}
        />
        <TableCaptionItem
          labelText="Pendência no E-social"
          icon={faCircle}
          color={theme.corColaboradorPendenciaESocial}
        />
      </CustomLabel6>
    </>
  );
}

export default LegendaSituacaoColaborador;
